<app-navbar></app-navbar>
<app-app-landing></app-app-landing>
<!-- <app-newsletter></app-newsletter> -->
<app-footer></app-footer>
<ngx-scrolltop></ngx-scrolltop>
